module.exports = __webpack_public_path__ + "static/body_6-4d815f749557645c2e0a612c7a5c3d8b.png";